import { render } from "./probaworkflows_layout.html?vue&type=template&id=519e1e32&external"
import script from "./probaworkflows_layout.js?vue&type=script&lang=js&external"
export * from "./probaworkflows_layout.js?vue&type=script&lang=js&external"

import "./ProbaWorkflowsLayout.vue?vue&type=style&index=0&id=519e1e32&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__